module.exports = __webpack_public_path__ + "img/my_bg.561eda41.png";